import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { obtenerFichaMatricula } from '../../../../services/matriculasService';
import FichaInscritoContent from '../components/FichaInscritoContent';

export default function FichaInscritoPage() {
  const { matriculaId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!matriculaId) return;
    obtenerFichaMatricula(matriculaId)
      .then((d) => {
        setData(d);
        const nombre = [d.apellidos, d.nombres].filter(Boolean).join(' ');
        if (nombre) document.title = nombre;
      })
      .catch((err) => setError(err.message || 'No se pudo cargar la ficha.'))
      .finally(() => setLoading(false));
  }, [matriculaId]);

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: 13, color: '#6c757d' }}>
        Cargando...
      </div>
    );
  }

  if (error || !data) {
    return (
      <div style={{ padding: 16, color: '#dc3545', fontSize: 13 }}>
        {error || 'No se encontró la ficha.'}
      </div>
    );
  }

  return <FichaInscritoContent data={data} />;
}
